import type { AgentState } from '@takeshape/schema';
import type { AIServiceDefaults } from '../common/llm.js';

export type CreateAiStateParams = {
  id: string;
  type: 'chat' | 'generate';
  aiDefaults?: AIServiceDefaults;
  defaultInput?: string | undefined;
  includeTransitions?: boolean;
};

export function createAiState(params: CreateAiStateParams): AgentState {
  const { id, type, aiDefaults, defaultInput, includeTransitions = true } = params;
  const result: AgentState = {
    name: type,
    execution: {
      type: type,
      service: aiDefaults?.service ?? '',
      model: aiDefaults?.generateModel ?? '',
      input: {
        type: 'arg'
      },
      attachments: {
        type: 'none'
      },
      systemPrompt: 'You are a helpful assistant.'
    }
  };

  if (defaultInput && type === 'chat' && includeTransitions) {
    result.transitions = [{ type: 'suspend', destination: id, input: defaultInput }];
  }

  return result;
}

export function extractMessageContent(arg: unknown): string | null {
  if (
    typeof arg === 'object' &&
    arg !== null &&
    'type' in arg &&
    'content' in arg &&
    arg.type === 'string' &&
    typeof arg.content === 'string'
  ) {
    return arg.content;
  }
  return null;
}
